import styled from 'styled-components';
import * as colors from '../../../common/styles/colors';

export const NotificationBoxV2Wrapper = styled.div`
  border-left 5px solid ${colors.unhealthy};
  background-color: #F6BE2E40;

  .notificationV2-box {
    padding: 6px 8px 6px 8px;
  }

  .notification-message-row {
    display: flex;
    gap: 10px;
  }

  .notification-badge {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: ${colors.unhealthy};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .notification-message {
    padding-top: 3px;
    text-align: left;
  }

  .notification-button {
    padding-left: 5px;
    text-wrap: nowrap;
  }
`;
